import React from "react";
import TextInput from "../../Components/Inputs/TextInput";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";
import ReactMultiSelectInput from "../../Components/Inputs/ReactMultiSelectInput";

export default function ({ register, errors, control, data, watch }) {

    return (
        <>
            <TextInput
                label="Name"
                name="name"
                parentClasses="col-md-6"
                register={register}
                required={true}
                errorMessage={errors?.name}
            />
            <TextInput
                label="Commission Rate (0.00 - 100.00) %"
                name="commission_rate"
                parentClasses="col-md-6"
                register={register}
                required={true}
                errorMessage={errors?.commission_rate}
            />
            <TextInput
                label="Consignment Days (Number)"
                name="consignment_days"
                parentClasses="col-md-6"
                register={register}
                required={true}
                errorMessage={errors?.consignment_days}
            />
            <ReactSelectInput
                label="Category"
                name="category_id"
                placeholder="Choose Category"
                inputClassName="col-md-6"
                register={register}
                options={data?.data?.categories}
                errorMessage={errors?.category_id}
                control={control}
                required={true}
            />
            <ReactMultiSelectInput
                label="Shops"
                name="shops"
                placeholder="Choose Shops"
                inputClassName="col-md-6"
                register={register}
                values={data?.data?.shops}
                errorMessage={errors?.shops}
                control={control}
                required={true}
            />
        </>
    );
}